// RootNavigation.js

import * as React from "react";
import ENV from "app/utils/ENV";
import { StackActions, DrawerActions, Link } from "@react-navigation/native";
import { StyleSheet, View, Linking } from "react-native";

export const navigationRef = React.createRef();

export function openNewTab(name, params = {}) {
  // Value?id=4439
  let paramString = Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");

  let url = window.location.href;
  url = url.slice(0, url.lastIndexOf("/"));
  url += `/${name}?${paramString}`;

  console.log(url);
  window.open(url, "_blank");
}

export function navigate(name, params, event = null) {
  if (!!event) {
    if (event.button == 1 || event.metaKey || event.newTab) {
      openNewTab(name, params);
      return;
    }
  }
  // console.log(navigationRef.current)
  navigationRef.current?.navigate(name, params);
  // navigationRef.current?.navigate({name, params, key: 'key?'})
  // navigationRef.current?.navigate(name, {
  //   screen: name,
  //   params,
  // });
}

// export function push(name, params) {
//   navigationRef.current?.push(name, params);
// }
export function push(...args) {
  let event = args[2];
  // console.log(event);
  if (!!event) {
    if (event.button == 1 || event.metaKey || event.newTab) {
      openNewTab(...args);
      return;
    }
  }
  navigationRef.current?.dispatch(StackActions.push(...args));
}

export function toggleDrawer() {
  navigationRef.current?.dispatch(DrawerActions.toggleDrawer());
}

export function popToTop() {
  navigationRef.current?.dispatch(StackActions.replace("Chapters"));
  return;
  // navigationRef.current?.popToTop();
  if (navigationRef.current.canGoBack()) {
    navigationRef.current?.dispatch(StackActions.popToTop());
  } else {
    let root = navigationRef.current.getRootState();
    let rootRoute = root.routeNames[root.index];
    // navigationRef.current.resetRoot();

    navigationRef.current?.dispatch(StackActions.replace(rootRoute));

    // navigationRef.current.navigate(rootRoute);
    // setTimeout(() => {
    //   console.log(navigationRef.current);
    //   // navigationRef.current.reset();
    // }, 0);
  }
}

export async function addListener(...args) {
  // console.log("adding listener", navigationRef.current);
  // if (!!navigationRef.current) {
  //   return navigationRef.current?.addListener(...args);
  // } else {
  let attemptsLeft = 3;
  while (attemptsLeft >= 0) {
    attemptsLeft--;

    if (!!navigationRef.current) {
      return navigationRef.current?.addListener(...args);
    } else {
      await setTimeout(async () => {
        if (!!navigationRef.current) {
          return navigationRef.current?.addListener(...args);
        } else {
          if (!attemptsLeft) {
            console.log("too many retries, giving up");
            return null;
          }
          console.log("retrying...");
        }
      }, 200);
    }
  }
  console.log("we souldnt be here....");
}

export function updateParams(param, newVal) {
  if (!ENV.WEB) return;
  console.log(param, newVal);
  let search = window.location.search;
  let regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  let query = search.replace(regex, "$1").replace(/&$/, "");
  let newParams =
    (query.length > 2 ? query + "&" : "?") +
    (newVal ? param + "=" + newVal : "");

  let newUrl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    newParams;
  window.history.pushState({ path: newUrl }, "", newUrl);
}

// function retryAddListener(...args) {
//   console.log("retrying");
//   return addListener(...args);
// }

// add other navigation functions that you need and export them
